<template>
  <div class="mb-3 checkbox-circle">
    <label>
      <question-display :question="question"  customClass="header-radio"></question-display>
    </label><br>
    <div v-for="option in question.options" :key="option" class="checkWidth">
      <label class="curved-checkbox">
        <input
          type="radio"
          :value="option"
          v-model="inputValue"
          @change="updateInput"
          class="form-check-input"
        /> &nbsp;&nbsp;{{ option }}
      </label>
    </div>
    <small v-if="showValidation && question.required && !inputValue" class="text-danger">This field is required.</small>
  </div>
</template>

<script>
import surveyService from '@/services/surveyService'; // Import the survey service
import QuestionDisplay from '../utils/QuestionDisplay.vue';

export default {
  components: {
      QuestionDisplay
  },
  props: {
    question: Object,
    required: Boolean,
    showValidation: Boolean // Add showValidation prop
  },
  data() {
    return {
      inputValue: surveyService.getAnswer(this.question.id) || ''
    };
  },
  methods: {
    updateInput() {
      surveyService.setAnswer(this.question.id, this.inputValue); // Save the answer directly through the service
      this.$emit('input', this.inputValue);
    }
  },
  watch: {
    question(newQuestion) {
      this.inputValue = surveyService.getAnswer(newQuestion.id) || '';
    }
  }
};
</script>